import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable, from } from "rxjs";
import { StorageService } from "./storage.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class Verification implements CanActivate {
  constructor(public storage: StorageService, public router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentUser = this.storage.fetchUserStorageData();
    if (currentUser) {
      if (!currentUser.isNumberVerified) {
        this.router.navigate(["auth", "verify-phone"]);
        return false;
      }
      if (!currentUser.isEmailVerified) {
        this.router.navigate(["auth", "verify-email"]);
        return false;
      }
      return true;
    } else {
      this.router.navigate(["auth", "login"]);
      return false;
    }
  }
}
